import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50">
      {/* ヘッダー */}
      <div className="bg-gradient-to-br from-orange-400 to-orange-500 text-white">
        <div className="max-w-3xl mx-auto px-6 py-10 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
          </div>
          <h1 className="text-3xl font-bold mb-2">プライバシーポリシー</h1>
          <p className="text-orange-100 text-sm">きらり保育園箕面</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-10">

        {/* ★ 要約バナー（先頭に目立つ形で表示） */}
        <div className="bg-orange-50 border-2 border-orange-300 rounded-2xl p-6 mb-10 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-full flex-shrink-0">
              <i className="ri-information-line text-xl"></i>
            </div>
            <h2 className="text-xl font-bold text-orange-900">このポリシーの要点</h2>
          </div>
          <div className="space-y-3">
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-orange-200">
              <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-lock-line text-green-600 text-lg"></i>
              </div>
              <div>
                <p className="font-bold text-gray-800 text-sm mb-1">第三者への開示は一切しません</p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ご提供いただいた個人情報は、法令に基づく場合を除き、第三者に提供・開示することはありません。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-orange-200">
              <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-delete-bin-line text-red-500 text-lg"></i>
              </div>
              <div>
                <p className="font-bold text-gray-800 text-sm mb-1">いつでも削除できます</p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ご本人からの申し出があれば、保有する個人情報をいつでも速やかに削除いたします。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 本文 */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 space-y-10">

          {/* 第1条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">1</span>
              個人情報の定義
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              本ポリシーにおける「個人情報」とは、個人情報保護法に定める個人情報、すなわち生存する個人に関する情報であって、当該情報に含まれる氏名、メールアドレス、その他の記述等により特定の個人を識別できるものをいいます。
            </p>
          </section>

          {/* 第2条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">2</span>
              個人情報の収集
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              当園は、以下の目的のために必要な範囲で個人情報を収集します。
            </p>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                勤務前の事前確認・連絡対応
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                資格・勤務情報の管理
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                オファー・採用に関するご連絡
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                その他、業務上必要な連絡
              </li>
            </ul>
          </section>

          {/* 第3条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">3</span>
              個人情報の利用目的
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              収集した個人情報は、上記の収集目的の範囲内でのみ利用します。あらかじめご本人の同意を得ることなく、目的外に利用することはありません。
            </p>
          </section>

          {/* 第4条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">4</span>
              第三者への提供・開示の禁止
            </h3>
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-3">
              <p className="text-sm text-green-800 font-semibold flex items-center gap-2">
                <i className="ri-shield-check-fill text-green-600"></i>
                当園は、ご提供いただいた個人情報を第三者に提供・開示・売却することは一切ありません。
              </p>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed">
              ただし、以下の場合はこの限りではありません。
            </p>
            <ul className="mt-2 space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                ご本人の同意がある場合
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                法令に基づき開示が必要な場合
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                人の生命・身体・財産の保護のために必要であり、ご本人の同意を得ることが困難な場合
              </li>
            </ul>
          </section>

          {/* 第5条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">5</span>
              個人情報の開示・訂正・削除
            </h3>
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-3">
              <p className="text-sm text-red-800 font-semibold flex items-center gap-2">
                <i className="ri-delete-bin-fill text-red-500"></i>
                ご本人からの申し出があれば、保有する個人情報をいつでも速やかに削除いたします。
              </p>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed">
              ご本人は、当園が保有する自己の個人情報について、開示・訂正・追加・削除・利用停止を請求することができます。ご請求の際は、下記お問い合わせ先までご連絡ください。ご本人確認の上、合理的な期間内に対応いたします。
            </p>
          </section>

          {/* 第6条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">6</span>
              個人情報の安全管理
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              当園は、個人情報の漏洩・滅失・毀損を防止するため、適切なセキュリティ対策を講じます。個人情報へのアクセスは、業務上必要な担当者に限定し、適切に管理します。
            </p>
          </section>

          {/* 第7条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">7</span>
              Cookieおよびアクセス解析
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              当サイトでは、サービス向上のためにCookieやアクセス解析ツールを使用する場合があります。これらにより収集される情報は、個人を特定するものではありません。ブラウザの設定によりCookieを無効にすることも可能ですが、一部機能が制限される場合があります。
            </p>
          </section>

          {/* 第8条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">8</span>
              ポリシーの変更
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              本ポリシーは、法令の改正やサービス内容の変更に伴い、予告なく改定する場合があります。改定後のポリシーは、本ページに掲載した時点から効力を生じるものとします。
            </p>
          </section>

          {/* 第9条 */}
          <section>
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2 border-b border-orange-100 pb-2">
              <span className="w-7 h-7 flex items-center justify-center bg-orange-500 text-white rounded-full text-xs font-bold flex-shrink-0">9</span>
              お問い合わせ
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              個人情報の取り扱いに関するお問い合わせ・開示・削除のご請求は、以下までご連絡ください。
            </p>
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
              <p className="text-sm font-bold text-gray-800 mb-2">きらり保育園箕面</p>
              <a
                href="mailto:info@kirari-hoiku.com"
                className="inline-flex items-center gap-2 text-orange-600 hover:text-orange-800 font-medium text-sm"
              >
                <i className="ri-mail-line"></i>
                info@kirari-hoiku.com
              </a>
            </div>
          </section>

          {/* 制定日 */}
          <div className="text-right text-xs text-gray-400 pt-4 border-t border-gray-100">
            制定日：2025年1月1日
          </div>
        </div>

        {/* 同意の注記 */}
        <div className="mt-8 bg-orange-50 border border-orange-200 rounded-xl p-5 text-center">
          <i className="ri-checkbox-circle-fill text-orange-500 text-2xl mb-2 block"></i>
          <p className="text-sm text-gray-700 leading-relaxed">
            フォームを送信することで、本プライバシーポリシーに<br />
            <strong className="text-orange-600">同意したものとみなします。</strong>
          </p>
        </div>

        {/* 戻るボタン */}
        <div className="mt-8 text-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 bg-white border-2 border-orange-300 text-orange-600 font-semibold px-6 py-3 rounded-xl hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            前のページに戻る
          </button>
        </div>
      </div>
    </div>
  );
}
